import { createStyles, Theme } from '@material-ui/core';

const styles = ({ colors, spacing, flags }: Theme) => createStyles({
  root: {
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: `1fr ${spacing(40)}px`,
    gridGap: spacing(2),
    marginBottom: colors.pageElements.notificationCard.rowsDistance,
    paddingTop: spacing(3),
    paddingRight: spacing(2),
    paddingBottom: spacing(3),
    paddingLeft: spacing(4),
    background: colors.pageElements.notificationCard.background,
    borderRadius: colors.pageElements.notificationCard.corner,
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      width: '100%',
      borderBottom: flags.boxStyle === 'stroke' ? `2px solid ${colors.pageElements.notificationCard.stroke}` : 'none',
    },
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  messageWrapper: {
    marginTop: spacing(1),
  },
  btnWrapper: {
    alignSelf: 'flex-end',
    justifySelf: 'flex-end',
  },
  messageWrapperClosed: {
    overflow: 'hidden',
    position: 'relative',
    maxHeight: spacing(12),
    '&::after': {
      content: '""',
      position: 'absolute',
      left: 0,
      right: 0,
      height: '45%',
      bottom: 0,
      background: colors.pageElements.notificationCard.fadingOverlay,
      pointerEvents: 'none',
    },
    '& $message': {
      marginTop: spacing(1),
    },
  },
  label: {
    color: colors.pageElements.indicator.text,
    backgroundColor: colors.pageElements.indicator.fill,
    borderRadius: colors.pageElements.indicator.corner,
    marginLeft: spacing(2),
    padding: `${spacing(0.5)}px ${spacing(2)}px`,
    textTransform: 'uppercase',
  },
  message: {
    marginTop: spacing(2),
    wordBreak: 'break-word',
  },
  iconActive: {
    transform: 'rotate(180deg)',
  },
});

export default styles;
